import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/community-image.png'
import _imports_1 from '@/assets/images/twitter-icon.png'
import _imports_2 from '@/assets/images/medium-icon.png'
import _imports_3 from '@/assets/images/discord-icon.png'
import _imports_4 from '@/assets/images/gitbook-logo.png'
import _imports_5 from '@/assets/images/github-logo.png'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { id: "modal" }, null, -1)
const _hoisted_2 = {
  id: "app",
  class: "flex flex-col"
}
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = { class: "relative px-4 pb-12 lg:px-12" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "relative flex items-end flex-1" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createVNode("div", { class: "absolute bottom-0 flex justify-center pb-6 ml-8 transform -translate-x-1/2 left-1/2" }, [
    /*#__PURE__*/_createVNode("a", {
      href: "https://twitter.com/beethoven_x",
      class: "mr-12"
    }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_1,
        width: "40",
        class: "mx-auto"
      })
    ]),
    /*#__PURE__*/_createVNode("a", {
      href: "https://beethovenxio.medium.com/",
      class: "mr-12"
    }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_2,
        width: "40",
        class: "mx-auto"
      })
    ]),
    /*#__PURE__*/_createVNode("a", {
      href: "https://discord.gg/jedS4zGk28",
      class: "mr-12"
    }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_3,
        width: "40",
        class: "mx-auto"
      })
    ]),
    /*#__PURE__*/_createVNode("a", {
      href: "https://docs.beethovenx.io/",
      class: "mr-12"
    }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_4,
        width: "40",
        class: "mx-auto"
      })
    ]),
    /*#__PURE__*/_createVNode("a", { href: "https://github.com/beethovenxfi" }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_5,
        width: "40",
        class: "mx-auto"
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppNav = _resolveComponent("AppNav")
  const _component_AppHeaderBg = _resolveComponent("AppHeaderBg")
  const _component_AppHero = _resolveComponent("AppHero")
  const _component_GlobalStats = _resolveComponent("GlobalStats")
  const _component_router_view = _resolveComponent("router-view")
  const _component_AppFooterNav = _resolveComponent("AppFooterNav")
  const _component_VueQueryDevTools = _resolveComponent("VueQueryDevTools")
  const _component_WalletSelectModal = _resolveComponent("WalletSelectModal")
  const _component_Notifications = _resolveComponent("Notifications")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_AppNav),
      _createVNode(_component_AppHeaderBg),
      _createVNode("div", _hoisted_3, [
        (_ctx.isInvestPage)
          ? (_openBlock(), _createBlock(_component_AppHero, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.showGlobalStats)
          ? (_openBlock(), _createBlock(_component_GlobalStats, { key: 1 }))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_router_view, {
          key: _ctx.$route.path,
          class: "flex-auto"
        })
      ]),
      (_ctx.upToLargeBreakpoint)
        ? (_openBlock(), _createBlock(_component_AppFooterNav, { key: 0 }))
        : _createCommentVNode("", true),
      _hoisted_5,
      _createVNode(_component_VueQueryDevTools),
      _createVNode(_component_WalletSelectModal, {
        isVisible: _ctx.isWalletSelectVisible,
        onClose: _ctx.toggleWalletSelectModal
      }, null, 8, ["isVisible", "onClose"]),
      _createVNode(_component_Notifications)
    ])
  ], 64))
}